export interface ProfileState {
  _id: string;
  firstName: string;
  lastName: string;
  language: string;
  defaultPhase: string;
  isMfaEnabled: boolean;
  email: string;
  active: boolean;
  theme?: 'dark' | 'light' | undefined;
  isLoading?: boolean;
  dataApiKey: APIToken;
  allowDataApi: boolean;
  allowImageApi: boolean;
  allowBiometricApi: boolean;
  settingTab?: SettingsTab;
}

export interface APIToken {
  _id: string;
  companyId: string;
  apiKey: string;
  url: string;
}

export interface Banner {
  companyIds: string[];
  en: string;
  es: string;
  pt: string;
  showAlert: boolean;
  persistentMode: boolean;
  endDate?: string;
  backgroundColor: string;
  icon: string;
  alertClosed?: boolean;
}

export interface ScheduleRuleState {
  _id: string;
  companyId: string;
  hours: string[];
  isLoading: boolean;
}

export interface ScheduleRule {
  _id: string;
  companyId: string;
  hours: string[];
}

export type SettingsTab = 'USER' |
  'PASSWORD' | 'API_SERVICE' | 'COUPON' |
  'BANNER' | 'SCHEDULE' | 'NOVELTIES' | 'MFA' |
  'EXTERNAL_ACCESS';

export const settingsTabs: Record<SettingsTab, SettingsTab> = {
  USER: 'USER',
  PASSWORD: 'PASSWORD',
  API_SERVICE: 'API_SERVICE',
  EXTERNAL_ACCESS: 'EXTERNAL_ACCESS',
  COUPON: 'COUPON',
  BANNER: 'BANNER',
  SCHEDULE: 'SCHEDULE',
  NOVELTIES: 'NOVELTIES',
  MFA: 'MFA',
};

export interface MfaState {
  isUpdating: boolean;
  isRemoving: boolean;
  mfaEmail?: Mfa;
  mfaAuthenticator?: Mfa;
  showCreateAuthenticatorAppModal: boolean;
  showCreateAuthenticatorEmailModal: boolean;
  qrCode?: string;
  isSendingEmail: boolean;
  showAuthenticatorEmailLabel: boolean;
}

export interface Mfa {
  enabled: boolean;
  verifiedAt: string;
}

export interface ExternalAccessState {
  externalAccess: ExternalAccess[];
  selectedExternalAccess?: ExternalAccess;
  isLoading: boolean;
  isCreating: boolean;
  showCreateModal: boolean;
  showEditModal: boolean;
}

export interface IntegrationAQ1State {
  isLoading: boolean;
  isUpdating: boolean;
  showModal: boolean;
  integratedPonds: IntegratedPond[];
  campuses: Campus[];
}

export interface ExternalAccess {
  _id?: string;
  companyId: string;
  active?: boolean;
  apiConfig: {
    name: string;
    user: string;
    password: string;
    url: string;
  };
}

export interface IntegratedPond {
  larvia: {
    tankId?: string;
    tankName?: string;
    campusId?: string;
    campusName?: string;
    moduleId?: string;
    moduleName?: string;
  };
  aq1: {
    externalAccessId: string;
    pondId: number;
    pondName: string;
    zoneGuids: string[];
    zoneNames: string[];
  }
}

export interface Campus {
  _id: string;
  name: string;
}

export interface Module {
  _id: string;
  name: string;
}

export interface Tank {
  _id: string;
  name: string;
}
